import React, { useContext } from 'react';

import * as FeatureFlagContext from "FeatureFlagContext"

export const CustomerContext = React.createContext();

const CONTEXTS = [
  FeatureFlagContext,
];

export default function CustomerProviderWrapper(props) {
  let providerTree = (
    <CustomerProvider contexts={props.contexts}>
      {props.children}
    </CustomerProvider>
  );

  props.contexts.forEach(context => {
    providerTree = (
      <context.default {...props.values[context.contextName]}>
        {providerTree}
      </context.default>
    );
  })

  return providerTree;
}

CustomerProviderWrapper.defaultProps = {
  contexts: CONTEXTS,
  values: {},
}

function CustomerProvider(props) {
  let values = {};
  props.contexts.forEach(mainContext => {
    const { contextName } = mainContext;
    const contextValues = useContext(mainContext[contextName]);

    values = {
      ...values,
      [contextName]: {
        ...contextValues,
      }
    };
  });

  return (
    <CustomerContext.Provider value={values}>
      {props.children}
    </CustomerContext.Provider>
  );
}

